import React, { FC, useState } from "react";
import { Form, Modal, Button, Alert, Row, Col } from "react-bootstrap";
import { Formik } from "formik";
import * as yup from "yup";
import ClipLoader from "react-spinners/ClipLoader";
import { FormattedMessage, useIntl } from "react-intl";
import { LANG_COMMON_CANCEL, LANG_COMMON_CHOOSE, LANG_COMMON_CODE, LANG_COMMON_NO, LANG_COMMON_SAVE, LANG_COMMON_YES, LANG_ERROR, LANG_PERSON_NEW_ROD, LANG_PERSON_ROD_FREEZING_DATE, LANG_PERSON_ROD_FRESH, LANG_PERSON_ROD_FROZEN, LANG_PERSON_ROD_OVULES_QTY, LANG_PERSON_ROD_TYPE, LANG_PERSON_ROD_USED, LANG_WARNING_FILL_ALL } from "../../../lang";
import { PairedPersonType, PersonType } from "../../../types/PersonType";
import PairedPersonCard from "../PairedPersonCard";
import { PersonModel } from "../../../models/PersonModel";
import RodsSelectList from "./RodsSelectList";
import { PairingModel } from "../../../models/PairingModel";

interface Props {
    show: boolean
    onHide: () => void
    onSave: () => void
    reference: PersonType
    selected: PairedPersonType
    bloodType: string
    rhFactor: string
    race: string
}
const PairingAddModal: FC<Props> = ({ show, onHide, onSave, reference, selected, bloodType, rhFactor, race }) => {
    const intl = useIntl();
    const schema = yup.object().shape({
        
    });
    const [formWasSubmitted, setFormWasSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [rodList, setRodList] = useState<string>("");    

    const onSubmit = async (values: any) => {
        setErrorMessage("");

        if(rodList === "") {
            setErrorMessage("Selecione os materiais biológicos.");
            return;
        }

        setLoading(true);
        setFormWasSubmitted(false);
        PairingModel().create(
            (reference.type === "R") ? reference.id : selected.id,
            {
                'donor': (reference.type === "R") ? selected.id : reference.id,
                'rod_list': rodList,
                'blood_type': bloodType,
                'rh_factor': rhFactor,
                'race': race
            }).then((resp) => {
                setLoading(false);
                onSave();
            });
    }

    return (
        <Modal
            show={show}
            onHide={() => {
                onHide();
                setFormWasSubmitted(false);
            }}
            className="modal-default"
        >
            <Formik
                validationSchema={schema}
                onSubmit={onSubmit}
                initialValues={{}}
            >
                {({
                    setFieldValue,
                    handleSubmit,
                    handleChange,
                    values,
                    touched,
                    isValid,
                    errors }) => (
                    <Form noValidate onSubmit={(e) => {
                        setFormWasSubmitted(true);
                        handleSubmit(e);
                    }}>
                        <Modal.Header closeButton closeVariant="white">
                            <Modal.Title>
                                Novo Pareamento
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {(!isValid && formWasSubmitted) && (<Alert variant={'danger'}><FormattedMessage {...LANG_WARNING_FILL_ALL} /></Alert>)}
                            {errorMessage !== "" && (<Alert variant={'danger'}>{errorMessage}</Alert>)}
                            {reference.business_id !== selected.business_id && (<Alert variant={'warning'}>Essa doadora pertence a outra clínica. Será enviado uma solicitação ao gestor.</Alert>)}
                            <div className="row">

                                <div className="col-md-6">
                                    <PairedPersonCard
                                        paired={PersonModel().toPairedPerson(reference)}
                                        onSelect={() => { }}
                                        stared={false}
                                        showChildPhoto={false}
                                        type={(reference.type === 'D') ? "D" : "R"}
                                        onSelectReport={() => { }}
                                        showSelectButton={false}
                                        showDetails={false}
                                        showCheckbox={false}
                                        showFaceQuality={false}
                                    />
                                    {reference.type === 'D' && (
                                        <div className="mt-3">
                                            <RodsSelectList donor={reference.id} key={reference.id} onSelect={(rodList) => {
                                                setRodList(rodList);
                                            }} />
                                        </div>
                                    )}
                                </div>
                                <div className="col-md-6">
                                    <Form.Group className="mb-3" controlId="name">
                                        <PairedPersonCard
                                            paired={selected}
                                            onSelect={() => { }}
                                            stared={false}
                                            showChildPhoto={false}
                                            type={(reference.type === 'D') ? "D" : "R"}
                                            onSelectReport={() => { }}
                                            showSelectButton={false}
                                            showDetails={false}
                                            showCheckbox={false}
                                            showFaceQuality={false}
                                        />
                                        {reference.type === 'R' && (
                                            <div className="mt-3">
                                                <RodsSelectList donor={selected.id} key={selected.id} onSelect={(rodList) => {
                                                    setRodList(rodList);
                                                }} />
                                            </div>
                                        )}
                                    </Form.Group>
                                </div>
                            </div>

                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="outline-light" onClick={onHide} className="btn-custom btn-custom-light">
                                {intl.formatMessage(LANG_COMMON_CANCEL)}
                            </Button>
                            <Button variant="primary" type={"submit"} disabled={loading} className="btn-custom bg-custom-gradient">
                                {loading ? <><ClipLoader color={'#ffffff'} loading={loading} size={'12px'} /></> : intl.formatMessage(LANG_COMMON_SAVE)}
                            </Button>
                        </Modal.Footer>
                    </Form>
                )}
            </Formik>
        </Modal>
    )
}

export default PairingAddModal;